import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, { useState } from "react";

const headers = [
  {
    key: "product_category_name",
    name: "Category Name",
  },
  {
    key: "sub_product_category_name",
    name: "Sub Category Name",
  },
  {
    key: "prefix_code",
    name: "Prefix Code",
  },
  {
    key: "status",
    name: "Status",
  },
];

export default function ProductCategoryList() {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/productCategory",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed); // Store search term
      setQuery({
        name: trimmed,
      });
    }else{
      setQuery({});
    }
  };

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Product Category List"
      data={data}
      headers={headers}
      idKey="product_category_id"
      endPoint="/productCategory"
      removeDetails={true}
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      module="Product"
      subModule="Product Category List"
      createPath={`/product/category/create`}
      hasActions
      currentPath={currentPath}
      onSearch={handleSearch}
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
}
